import React, { useState, useContext, useEffect } from "react";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group"
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import ContainerSearchTab from "./searchTabs/ContainerSearchTab";
import WorkcellSearchTab from "./searchTabs/WorkcellSearchTab";
import AssociateSearchTab from "./searchTabs/AssociateSearchTab";
import {FormattedMessage} from "react-intl";
import PackageSearchTab from "./searchTabs/PackageSearchTab";
import {isINRegion} from "../../util/CommonUtils";
import {PAGE_HEADERS, ACTION_TYPE, FEATURES} from "../../commons/constants/CommonConstants";
import PageHeader from "../../commons/PageHeader";
import {getFeaturesFromParent} from "../../handler/ParentDataHandler";
import {chainWalk} from "../../commons/CommonUtils";
import {FeatureConfigContext} from "../../commons/context/FeatureConfigContext";
import Loader from "@amzn/meridian/loader";
import {useDeviceLayout} from "../../commons/context/DeviceLayoutContext";

export const SearchView = (props) => {
    const [currentTab, setCurrentTab] = useState("Packages");
    const {configViewModel, configDispatch} = useContext(FeatureConfigContext)
    const {spacingInset_shorthand5} = useDeviceLayout();
    const isASLLatestProtocol = chainWalk(() => configViewModel.featureStatus[FEATURES.ASL_LATEST_PROTOCOL], false);
    const isAssociateSearchDialedDown = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_ASSOCIATE_SEARCH_DIAL_DOWN], false);

    useEffect(() => {
        getFeaturesFromParent([FEATURES.ASL_LATEST_PROTOCOL, FEATURES.IS_ASSOCIATE_SEARCH_DIAL_DOWN]).then(featureStatus => {
            configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
        })
    }, [])

    if(configViewModel.loading) {
        return (
            <Column alignmentHorizontal="center">
                <Loader/>
            </Column>
        )
    } else {
        return (
            <Column spacingInset={spacingInset_shorthand5}>
                <PageHeader {...PAGE_HEADERS.SEARCH}/>
                <Row spacingInset="none">
                    <ButtonGroup value={currentTab} onChange={setCurrentTab} type="fill">
                        <ButtonOption value="Packages">
                            <FormattedMessage id="search.packages" defaultMessage="Packages"/>
                        </ButtonOption>
                        {isINRegion() ? null : <ButtonOption value="Container">
                            <FormattedMessage id="search.container" defaultMessage="Container"/>
                        </ButtonOption>}
                        {isINRegion() || isAssociateSearchDialedDown ? null : <ButtonOption value="Associate">
                            <FormattedMessage id="search.associate" defaultMessage="Associate"/>
                        </ButtonOption>}
                        {isINRegion() || !isASLLatestProtocol ? null : <ButtonOption value="Workcell">
                            <FormattedMessage id="search.workcell" defaultMessage="Workcell"/>
                        </ButtonOption>}
                    </ButtonGroup>
                </Row>
                {currentTab === "Packages" ? <PackageSearchTab baseURL={props.baseURL} nodeId={props.nodeId}/> :
                    currentTab === "Container" ? <ContainerSearchTab/> :
                        currentTab === "Workcell" ? <WorkcellSearchTab/> :
                            currentTab === "Associate" ? <AssociateSearchTab/> : null}
            </Column>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/detailPages/SearchView.js